<template>
  <div class="levo-sirsi">
    <div class="levo-sirsi__nazev-webu"></div>

    <div class="levo-sirsi__dole">
      <LevoUser />
      <div class="levo-sirsi__dole__buttons">
      <LevoHowTo text="How to play"  @leave="openModalHowTo" />
      <LevoLeave text="Sign out " @leave="signOut" />
      <ModalHowTo ref="modalRefHow" width="450px">
      <div class="modal__questionHeader">
        Tutorials
      </div>
      <div class="clearfix">
        <a href="https://vimeo.com/664261088/e8ff4278b0" target="_blank">
          <div class="login__videos__video__button">
             Registration and joining a game
          </div>
        </a>
        <a href="https://vimeo.com/664261114/59f83f689a" target="_blank">
          <div class="login__videos__video__button">
             How to play 
          </div>
        </a>
        <a href="https://vimeo.com/664261179/9878514058" target="_blank">
          <div class="login__videos__video__button">
             Tips & tricks 
          </div>
        </a>
      </div>
    </ModalHowTo>
    </div>
    </div>

    <LevoAbout />
  </div>
</template>

<script>
// import LevoTlacitka from "@/components/welcome/levo/LevoTlacitka.vue";
import LevoAbout from "@/components/welcome/levo/LevoAbout.vue";
import ModalHowtojs from "@/components/general/ModalHowTo.js";
import LevoUser from "@/components/general/LevoUser.vue";
import ModalHowTo from "@/components/general/ModalHowTo.vue";
import LevoLeave from "@/components/general/LevoLeave.vue";
import LevoHowTo from "@/components/general/LevoHowTo.vue";

export default {
  name: "Levo",
  mixins: [ModalHowtojs],
  components: {
    // LevoTlacitka,
    LevoAbout,
    LevoLeave,
    LevoUser,
    LevoHowTo,
    ModalHowTo
  },
  methods: {
    
    async signOut() {
      await this.$store.dispatch("signOut");
    },
  },
};
</script>
